export const EDIT_TAB_ONGOING = "ON-GOING";
export const EDIT_TAB_COMMENCED = "COMMENCED";
